import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BookmarksState {
  bookmarkedEventIds: string[];
}

const initialState: BookmarksState = {
  bookmarkedEventIds: [],
};

const bookmarksSlice = createSlice({
  name: 'bookmarks',
  initialState,
  reducers: {
    /** Sync bookmarked event IDs from the server-side list query */
    setBookmarkedEventIds: (state, action: PayloadAction<string[]>) => {
      state.bookmarkedEventIds = action.payload;
    },
    /** Optimistically toggle a single event ID in the bookmarkedEventIds list */
    toggleBookmarkedEventId: (state, action: PayloadAction<string>) => {
      const idx = state.bookmarkedEventIds.indexOf(action.payload);
      if (idx >= 0) {
        state.bookmarkedEventIds.splice(idx, 1);
      } else {
        state.bookmarkedEventIds.push(action.payload);
      }
    },
    setBookmarkState: (state, action: PayloadAction<{ id: string; bookmarked: boolean }>) => {
      const idx = state.bookmarkedEventIds.indexOf(action.payload.id);
      if (action.payload.bookmarked && idx === -1) {
        state.bookmarkedEventIds.push(action.payload.id);
      } else if (!action.payload.bookmarked && idx >= 0) {
        state.bookmarkedEventIds.splice(idx, 1);
      }
    },
  },
});

export const { setBookmarkedEventIds, toggleBookmarkedEventId, setBookmarkState } =
  bookmarksSlice.actions;
export default bookmarksSlice.reducer;
